export enum CompanyStatuses {
  none = '',
  inActive = 'InActive',
  active = 'Active'
}
